import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../environments/environment';
import { User } from './models/user.model';
import { SignatureHtmlService } from './services/signature-html.service';
import { UserService } from './services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  users: User[] = [];
  selectedUser: User | null = null;
  copyMessage = '';

  @ViewChild('signatureBlock') signatureBlock?: ElementRef<HTMLElement>;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private signatureHtml: SignatureHtmlService
  ) {}

  ngOnInit(): void {
    this.userService.getUsers().subscribe(users => {
      this.users = users;
      this.route.queryParams.subscribe(params => {
        if (params?.user) {
          this.selectedUser = this.userService.findBySlug(this.users, params.user);
        }
      });
    });
  }

  assetUrl(path: string): string {
    const base = environment.assetBaseUrl || window.location.origin;
    return `${base}/${path.replace(/^\//, '')}`;
  }

  copySignature(): void {
    if (!this.selectedUser) {
      return;
    }

    const html = this.signatureHtml.buildEmailHtml(this.selectedUser);
    const plain = this.signatureHtml.buildPlainText(this.selectedUser);

    this.copyHtmlToClipboard(html, plain)
      .then(() => {
        this.copyMessage = 'Firma copiada. Pégala en Gmail o Outlook.';
        setTimeout(() => this.copyMessage = '', 4000);
      })
      .catch(() => {
        this.copyMessage = 'No se pudo copiar. Intenta de nuevo.';
        setTimeout(() => this.copyMessage = '', 4000);
      });
  }

  private copyHtmlToClipboard(html: string, plain: string): Promise<void> {
    const navigatorAny = navigator as any;
    const ClipboardItemCtor = (window as any).ClipboardItem;

    if (navigatorAny.clipboard && ClipboardItemCtor) {
      return navigatorAny.clipboard.write([
        new ClipboardItemCtor({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([plain], { type: 'text/plain' })
        })
      ]);
    }

    const container = document.createElement('div');
    container.innerHTML = html;
    container.style.position = 'fixed';
    container.style.left = '-9999px';
    document.body.appendChild(container);

    const selection = window.getSelection();
    if (!selection) {
      document.body.removeChild(container);
      return Promise.reject(new Error('Clipboard not supported'));
    }

    const range = document.createRange();
    range.selectNodeContents(container);
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand('copy');
    selection.removeAllRanges();
    document.body.removeChild(container);
    return Promise.resolve();
  }
}
